import { render, staticRenderFns } from "./BatchContainer.vue?vue&type=template&id=13f9c677&scoped=true&"
import script from "./BatchContainer.vue?vue&type=script&lang=js&"
export * from "./BatchContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f9c677",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VPagination})
